export const SDK_VERSION = '7.25.0';
